<template>
  <div id="app">
    <el-row>
      <el-col :span="20">
Passo 3 - PROPOSTA

      </el-col>
    </el-row>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" >
       <el-form-item label="1. PROPOSTA COMERCIAL" prop="proposta">
        <vue-editor id="proposta" v-model="ruleForm.proposta"></vue-editor>
      </el-form-item>
       <el-form-item label="2. COMPILAÇÃO DE VALORES" prop="valores">
           <el-table :data="tableValores"  style="width: 100%" empty-text="Sem dados!">
      <el-table-column   prop="item" label="Item" width="180">
      </el-table-column>
      <el-table-column prop="descricao" label="Descrição" width="180">
      </el-table-column>
      <el-table-column prop="ncm" label="NCM">
      </el-table-column>
      <el-table-column prop="icms" label="ICMS">
      </el-table-column>
      <el-table-column prop="ipi" label="IPI">
      </el-table-column>
      <el-table-column prop="valor_sem_ipi" label="Valor s/ IPI">
      </el-table-column>
      <el-table-column prop="valor_com_ipi" label="Valor c/ IPI">
      </el-table-column>
    </el-table>
      </el-form-item>
       <el-form-item label="3. IMPOSTOS" prop="impostos">
         <br>
        <ul style='text-align:left;'>
          <li style='text-align:left;'>ICMS: 18% incluso;</li>
          <li style='text-align:left;'>PIS/COFINS: 9,25% incluso</li>
          <li style='text-align:left;'>IPI: 15% a incluir</li>
          <li style='text-align:left;'>VER SE ESTES DADOS É PARA PUXAR DA PROPOSTA OU DEIXAR FIXOS</li>
        </ul>
      </el-form-item>      
        <el-form-item label="Redução de ICMS" prop="reducao">
        <vue-editor id="reducao" v-model="ruleForm.reducao"></vue-editor>
      </el-form-item>
       <el-form-item label="Produtos com redução" prop="reducao">
        <vue-editor id="reducao" v-model="ruleForm.reducao"></vue-editor>
      </el-form-item>      
      <el-form-item label="4. CONDIÇÕES DE PAGAMENTO" prop="pagamento">
        <vue-editor id="pagamento" v-model="ruleForm.pagamento"></vue-editor>
      </el-form-item>      
      <el-form-item label="5. FRETE" prop="frete">
        <vue-editor id="frete" v-model="ruleForm.frete"></vue-editor>
      </el-form-item>      
      <el-form-item label="6. GARANTIA" prop="garantia">
        <vue-editor id="garantia" v-model="ruleForm.garantia"></vue-editor>
      </el-form-item>      
      <el-form-item label="7. VALIDADE DA PROPOSTA" prop="validade">
        <vue-editor id="validade" v-model="ruleForm.validade"></vue-editor>
      </el-form-item>      
      <el-form-item label="8. PRAZO DE ENTREGA" prop="entrega">
        <vue-editor id="entrega" v-model="ruleForm.entrega"></vue-editor>
      </el-form-item>      
        <el-form-item label="NBRTec" prop="nbrtec">
          <el-input type="textarea" v-model="ruleForm.nbrtec"></el-input>
        </el-form-item>
        <el-form-item label="Cliente" prop="cliente">
          <el-input type="textarea" v-model="ruleForm.cliente"></el-input>
        </el-form-item>        
</el-form>        
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
   components: {
    VueEditor,
  },
   data() {
    return {
        tableValores: [{
            item: '1',
            descricao: 'dados puxados da proposta',
            ncm: '9999.99.99',
            icms: '99',
            ipi: '99',
            valor_sem_ipi: '99,99',
            valor_com_ipi: '99,99',
        }],      
       ruleForm: {
        proposta: "<h1 style='text-align:left;'>1. PROPOSTA COMERCIAL</h1><br><p>Esta proposta em como escopo comercial para o fornecimento de quadro de comando.</p><p>A elaboração desta proposta foi fundamentada nos seguintes documentos listados abaixo:</p><ul><li>e-mail do dia 19/03/2020</li></ul><p>Importante salientar que qualquer alteração no mesmo requer uma revisão da Proposta Técnica e Comercial.</p>",
        reducao: "<h1 style='text-align:left;'>Produtos com redução de ICMS baseado no enquadramento abaixo:</h1><br><p>¹Produtos de informática classificados na posição 8471 e nas subposições 8473.30, 8504.40 e 8534.00, e, desde que de tecnologia digital, nas posições 8536, 8537, 9029, 9030, 9031 e 9032, da NBM/SH-NCM, nas saídas do estabelecimento fabricante;</p>",
        pagamento: "<h1 style='text-align:left;'>4. CONDIÇÕES DE PAGAMENTO</h1><br><ul><li>30/45/60 dias após faturamento;</li></ul>",
        frete: "<h1 style='text-align:left;'>5. FRETE</h1><br><ul><li>Materiais/equipamentos entregues na modalidade CIF, na Saur em Panambi - RS;</li><li>Embalagem inclusa;</li></ul>",
        garantia: "<h1 style='text-align:left;'>6. GARANTIA</h1><br><p>Os equipamentos e acessórios propostos têm garantia contra defeitos decorrentes de vício de fabricação, defeito de peças e mão de obra de montagem pelo período de 12 (doze meses), contados a partir da data de entrega dos equipamentos em fábrica. Os possíveis defeitos de fabricação serão comprovados em termos de menutenção na fábrica, com quaisquer outras despesas por conta do cliente.</p><p>A NBRTec Indústria Elétrica não se responsabiliza por danos causados devido ao mau uso do equipamento.</p>",
        validade: "<h1 style='text-align:left;'>7. VALIDADE</h1><br><ul><li>A proposta tem validade de 10 dias.</li></ul>",
        entrega: "<h1 style='text-align:left;'>8. PRAZO DE ENTREGA</h1><br><ul><li>Recebimento da ordem de compra;</li><li>Depósito na conta da NBRTec da parcela referente a confirmação do pedido;</li><li>Recebimento de todas as informações necessárias a fabricação;</li><li>Aprovação dos projetos;</li></ul>",
        nbrtec:'',
        cliente:'',
       },
    };

  },
  methods: {
  
    }
};
</script>

<style>
#proposta  {
  height: 350px;
}
</style>

